<template>
	<div :key="customKey">
		<div class="demo-upload-list" v-for="item in fileTextComp.rentUploadList">
			<template>
				<img :src="api_domain + item" />
				<div class="demo-upload-list-cover">
					<Icon type="ios-eye-outline" @click.native="handleViewRent(item)"></Icon>
					<Icon type="ios-trash-outline" @click.native="handleRemoveRent(item)"></Icon>
				</div>
			</template>
		</div>
		<Upload
			ref="upload"
			:show-upload-list="false"
			:on-success="handleSuccessRent"
			:format="['jpg', 'jpeg', 'png']"
			:max-size="15360"
			:on-format-error="handleFormatErrorRent"
			:on-exceeded-size="handleMaxSizeRent"
			:before-upload="handleBeforeUploadRent"
			multiple
			type="drag"
			:action="api_domain + 'file/upload/'"
			style="display: inline-block; width: 58px; margin-bottom: 15px;"
		>
			<div style="width: 58px; height: 58px; line-height: 58px;" class="d-flex justify-content-center align-items-center">
				<Icon type="ios-camera" size="20"></Icon>
			</div>
		</Upload>

		<Modal title="View Image" v-model="fileTextComp.visibleRentModal">
			<img :src="api_domain + fileTextComp.imgName" v-if="fileTextComp.visibleRentModal" style="width: 100%;" />
		</Modal>

		<div class="d-flex align-items-center">
			<Input v-model="fileTextComp.valueRent" placeholder="Enter something..." />

			<div class="d-flex align-items-center ml-4">
				<InputNumber v-model="fileTextComp.priceRent" :value="+0" :min="+0" style="margin-right: 5px; max-width: 78px;" placeholder="0"></InputNumber>
				<span>Lei</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'CompetitionFileInputComponent',
		props: ['compFileText', 'customKey'],
		data() {
			return {
				fileTextComp: {},
			};
		},
		methods: {
			handleViewRent(name) {
				console.log('name', name);
				this.fileTextComp.imgName = name;
				this.fileTextComp.visibleRentModal = true;
			},
			handleRemoveRent(file) {
				// const fileList = this.$refs.upload.fileList;
				const fileList = [...this.fileTextComp.rentUploadList];
				this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				this.fileTextComp.rentUploadList.splice(fileList.indexOf(file), 1);
			},
			handleSuccessRent(res, file) {
				console.log('file', file);
				file.url = file.response.path;
				file.name = file.response.originalname;
				this.fileTextComp.rentUploadList.push(file.response.path);
			},
			handleFormatErrorRent(file) {
				this.$Notice.warning({
					title: 'The file format is incorrect',
					desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.',
				});
			},
			handleMaxSizeRent(file) {
				this.$Notice.warning({
					title: 'Exceeding file size limit',
					desc: 'File  ' + file.name + ' is too large, no more than 15M.',
				});
			},
			handleBeforeUploadRent() {
				const check = this.fileTextComp.rentUploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.',
					});
				}
				return check;
			},
		},
		mounted() {
			if (this.compFileText) {
				this.fileTextComp = this.compFileText;

				this.fileTextComp.rentUploadList = [...this.fileTextComp.rentUploadList, ...this.$refs.upload.fileList];
				this.fileTextComp.priceRent = this.fileTextComp.priceRent > 0 ? this.fileTextComp.priceRent : 0;
			}
		},
	};
</script>

<style scoped>
	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
		margin-right: 4px;
	}
	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}
	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, 0.6);
	}
	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}
	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>



// WEBPACK FOOTER //
// src/components/competitions/utils/CompetitionFileInputComponent.vue